import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="cursor-pointer">
              <img 
                src="https://i.ibb.co/fYd7kNHp/file-000000009ccc71f4afb9271f0a21b384-1.png"
                alt="Goodys Streams Logo"
                className="h-12 w-auto object-contain"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#premium" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">Premium</a>
            <a href="#features" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">Features</a>
            <a href="#pricing" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">Pricing</a>
            <a href="#support" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">Support</a>
            <a href="#faq" className="text-gray-700 hover:text-orange-500 transition-colors whitespace-nowrap cursor-pointer">FAQ</a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-orange-500 focus:outline-none cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#premium" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">Premium</a>
              <a href="#features" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">Features</a>
              <a href="#pricing" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">Pricing</a>
              <a href="#support" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">Support</a>
              <a href="#faq" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">FAQ</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}